<template>
    <div class="card">
        <div class="card-header">Preise löschen</div>
        <div class="card-body">
            <b-form-group>
                <b-form-radio-group
                    v-model="deletePricesInAllTabs"
                    class="full-width"
                    buttons
                    button-variant="outline-primary"
                    :options="type"
                    name="round"
                />
            </b-form-group>
            <AreYouSure confirm-msg="Preise löschen!" @confirm="resetPrices()">
                <b-button variant="outline-danger" class="full-width">
                    Preise löschen?
                </b-button>
            </AreYouSure>
        </div>
    </div>
</template>

<script>
import AreYouSure from "@/views/shared/widgets/AreYouSure";
export default {
    name: "DeletePrices",
    components: { AreYouSure },
    data() {
        return {
            deletePricesInAllTabs: false,
            type: [
                { text: "Tabelle", value: false },
                { text: "Gesamt", value: true }
            ]
        };
    },
    methods: {
        resetPrices() {
            this.$store.dispatch("resetPricing", this.deletePricesInAllTabs);
        }
    }
};
</script>

<style scoped>
.full-width {
    width: 100%;
    margin: 0;
}
</style>
